<button class="cx_button_pdf"
[disabled]=" isDisabled ? true : false"
[ngClass]="{'cx_button--primary': isPrimaryButton,'not-allowed': isDisabled}" >
	<i class="pi pi-fw" [class]="iconoPdf"></i>
</button>